<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 2C8.395 2 7.8066 2.05312 7.2348 2.15553C6.84951 2.22454 6.83164 2.75293 7.1873 2.9164C10.6208 4.49447 13 7.95185 13 12C13 16.0481 10.6208 19.5055 7.1873 21.0836C6.83164 21.2471 6.84951 21.7755 7.2348 21.8445C7.8066 21.9469 8.395 22 9 22C10.3132 22 11.6136 21.7413 12.8268 21.2388C14.0401 20.7362 15.1425 19.9997 16.0711 19.0711C16.9997 18.1425 17.7362 17.0401 18.2388 15.8268C18.7413 14.6136 19 13.3132 19 12C19 10.6868 18.7413 9.38642 18.2388 8.17317C17.7362 6.95991 16.9997 5.85752 16.0711 4.92893C15.1425 4.00035 14.0401 3.26375 12.8268 2.7612C11.6136 2.25866 10.3132 2 9 2Z"
      fill="currentColor" />
  </svg>
</template>
